import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";
import axios from "axios";
import PartnerInfoForm from "./PartnerInfoForm";

const EditSettingsModal = props => {
  const { partner } = props;
  const { settings } = partner;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [requestsPerDay, setRequestsPerDay] = useState(settings.requestsPerDay);
  const [dataFrequency, setDataFrequency] = useState(
    settings.dataFrequencySetting
  );
  const [partnerFilterType, setPartnerFilterType] = useState(
    settings.partnerFilterType
  );
  const [numberPerBusiness, setNumberPerBusiness] = useState(
    settings.numberPerBusiness
  );

  const onSubmit = async () => {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      setIsSubmitting(true);

      const payload = createPayload();

      const { data } = await axios.put(
        `api/proxy/v2/partneradmin/${partner.id}/settings`,
        payload,
        { headers }
      );
      props.onSuccess(data);
    } catch (e) {
      console.log(e.response || e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const createPayload = () => {
    return {
      requestsPerDay: Number(requestsPerDay),
      dataFrequency,
      partnerFilterType,
      numberPerBusiness: Number(numberPerBusiness)
    };
  };

  return (
    <Modal isOpen={props.isOpen} className={props.className}>
      <ModalHeader toggle={props.close}>Update Partner Settings</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Requests Per Day</Label>
          <Input
            type="number"
            value={requestsPerDay}
            onChange={e => setRequestsPerDay(e.target.value)}
          />
          <div style={{ marginTop: 10 }}>
            <Label>Data Frequency</Label>
            <Input
              type="select"
              name="frequency-select"
              value={dataFrequency}
              onChange={e => setDataFrequency(e.target.value)}
            >
              <option>realtime</option>
              <option>daily</option>
            </Input>
          </div>

          <div style={{ marginTop: 10 }}>
            <Label>Filter Type</Label>
            <Input
              type="select"
              name="filtertype-select"
              value={partnerFilterType}
              onChange={e => setPartnerFilterType(e.target.value)}
            >
              <option>business</option>
              <option>geofence</option>
            </Input>
          </div>
          <div style={{ marginTop: 10 }}>
            <Label>Number Per Business</Label>
            <Input
              type="number"
              value={numberPerBusiness}
              onChange={e => setNumberPerBusiness(e.target.value)}
            />
          </div>
        </FormGroup>
        <Button
          type="submit"
          className="pull-right"
          style={{ backgroundColor: "#20bed6" }}
          onClick={onSubmit}
        >
          {isSubmitting && (
            <i
              className="fa fa-circle-o-notch fa-spin"
              style={{ marginRight: 5 }}
            />
          )}
          Save
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default EditSettingsModal;



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/EditSettingsModal.js